import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

/**
 * Pipe for adding safeHtml to innerHtml attributes.
 *
 * @example <iframe [src]="="dynamicUrl | safeUrl"></iframe>
 */
@Pipe({
    name: 'safeUrl',
    standalone: false
})
export class SafeUrlPipe implements PipeTransform {
    constructor(private domSanitizer: DomSanitizer) {
    }

    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}
